import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { WINDOW } from '@inshared/shared/util';
import { NewModalRef } from 'outshared-lib';

@Component({
    selector: 'ins-new-residence-modal',
    templateUrl: './new-residence.modal.html'
})
export class NewResidenceModalComponent {
    constructor(
        private activeModal: NewModalRef<NewResidenceModalComponent>,
        @Inject(DOCUMENT) private document: Document,
        @Inject(WINDOW) private window: Window,
    ) {}

    public sluiten(): void {
        this.activeModal.close();
    }

    public newResidence(): void {
        this.window.location.href = this.document.location.origin + `/woonverzekering/berekenen-woonverzekering#?scenario=toevoegen`;
    }

    public changeResidence(): void {
        this.window.location.href = this.document.location.origin + `/mijn-verzekeringsmap/woonadres#/woonadres/wijzigen`;
    }
}
